import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Message, Request, Attachment, AttachmentDetail } from './request.model';

@Injectable({
  providedIn: 'root',
})
export class RequestsService {

  private url: string = environment.serverUrl;

  tabChange = new EventEmitter<any>();
  openCounter = new EventEmitter<any>();
  closedCounter = new EventEmitter<any>();
  invoicedCounter = new EventEmitter<any>();
  refreshRequest = new EventEmitter<boolean>();

  openRequestsWithNewMessages = 0;
  invoiceRequestsWithNewMessages = 0;
  closedRequestsWithNewMessages = 0;

  constructor(private http: HttpClient) { }

  tabChanged(tab: number): void{
    this.tabChange.emit(tab);
  }

  refreshRequests(refresh: boolean): void{
    this.refreshRequest.emit(refresh);
  }

  fetchRequests(): Observable<any> {
    return this.http.get(this.url + 'requests');
  }

  getRequestById(id: number): Observable<any> {
    return this.http.get(this.url + 'requests/' + id);
  }

  deleteRequest(id: number): Observable<any> {
    return this.http.delete(this.url + 'requests/' + id);
  }

  getRequestByStatus(page: number, paginationSize: number,
                     orderBy: string, sortDirection: string, requestStatus: number  ): Observable<Request[]> {
    return this.http.get<any>(this.url + 'requests?page=' + page + '&size=' + paginationSize + '&sortDirection=' +
      sortDirection + '&sortBy=' + orderBy + '&requestStatus=' +  requestStatus );
  }

  putRequest(request: Request): Observable<any> {
    return this.http.put(this.url + 'requests', request);
  }

  getExcelFile(): Observable<any> {
    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    });
    return this.http.post(this.url + 'requests/export', null, { headers, responseType: 'blob' });
  }


  // -- messages --
  getNotAssignedMessages(): Observable<any> {
    return this.http.get(this.url + 'messages');
  }

  deleteMessage(id: string): Observable<any> {
    return this.http.delete(this.url + 'messages/' + id);
  }

  assignMessage(requestId: number, messageId: number): Observable<any> {
    return this.http.put(
      this.url + 'requests/' + requestId + '/messages/' + messageId + '/assign',
      null
    );
  }

  sendMessage(internalRequestId: number, messages: Message[], attachments: Attachment[]): Observable<any> {
    return this.http.post(
      this.url + 'messages?internalRequestId=' + internalRequestId,
      {messages, attachments}
    );
  }

  getMessageByRequestId(requestId: number): Observable<AttachmentDetail[]> {
    return this.http.get<AttachmentDetail[]>(
      this.url + 'requests/search?externalRequestId=' + requestId
    );
  }

  getMessageTemplates(): Observable<any> {
    return this.http.get(this.url + 'messageTemplates');
  }

  getRequestsWithNewMessages(requestStatus: number): Observable<number> {
    return this.http.get<any>(this.url + 'requests/newmessages?requestStatus=' + requestStatus);
  }

  // attachments

  getAttachmentDetails(messageId: string): Observable<any> {
    return this.http.get(this.url + 'messages/' + messageId + '/attachments');
  }

  getAttachment(attachmentId: string): Observable<any> {
    return this.http.get(this.url + 'messages/attachments/' + attachmentId);
  }

  getRequestAttachment(requestAttachmentId: number): Observable<any> {
    return this.http.get(this.url + 'requests/attachments/' + requestAttachmentId);
  }

}
